import { Icon } from './Icon'
import type { IconProps } from './Icon'
export const PauseIcon = (p: IconProps) => <Icon {...p}><rect x="6" y="4" width="4" height="16" /><rect x="14" y="4" width="4" height="16" /></Icon>
